






import { defineComponent } from '~/utils/nuxt3-migration'
export default defineComponent({
  props: {
    width: {
      type: String,
      required: false,
      default() {
        return '100%'
      }
    },
    height: {
      type: String,
      required: false,
      default: null
    }
  }
})
